<template>
    <div v-if="withButton">
        <b-form-group v-bind="$attrs">
            <b-button variant="primary" @click="editor.show = true"> {{ btnLabel }} </b-button>
        </b-form-group>

        <b-modal :title="$attrs.label" size="xl" v-model="editor.show" hide-footer>
            <b-form-group 
                :description="editor_description"
            >
              <codemirror 
                ref="editor"
                @input="onChange"
                :placeholder="placeholder" 
                v-model="content" 
                :options="editorOptions"
                >
                </codemirror>

                <small v-for="(error, index) in errors" :key="index">  {{ error }}  </small>
            </b-form-group>
            <slot></slot>
        </b-modal>
    </div>
     <b-form-group 
        v-else
        :description="editor_description"
    >
        <codemirror 
        ref="editor"
        @input="onChange"
        :placeholder="placeholder" 
        v-model="content" 
        :options="editorOptions"
        >
        </codemirror>

        <small v-for="(error, index) in errors" :key="index">  {{ error }}  </small>
    </b-form-group>
</template>

<style scoped>
.editor-controls {
    margin: 5px 0px 10px 0px;
    padding: 0;
    list-style: none;
}

.editor-controls > li {
    display: inline-block;
    margin: 0px 5px;
}

.line-error {
    background-color: red
}

.libs-editor-wrapper {
    height: 100px;
}

</style>

<style>
.CodeMirror-hints {
    z-index: 9999;
}
</style>

<script>
// require component
import * as vueCodemirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/display/autorefresh.js'
import 'codemirror/addon/display/placeholder.js'
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/anyword-hint.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/selection/mark-selection.js'
import 'codemirror/addon/selection/active-line.js'
import 'codemirror/addon/hint/html-hint.js'
import 'codemirror/theme/material-palenight.css'

export default {
    components: {
        codemirror: vueCodemirror.codemirror
    },
    props: {
        value: {
            type: String
        },
        placeholder: {
            type: String
        },
        controls: {
            type: Array,
            default: function() {
                return ['*'];
            }
        },
        editor_description: {
            type: String
        },
        libs: {
            type: Array,
            default: function() {
                return []
            }
        },
        vars: {
            type: Array,
            default: function() {
                return []
            }
        },
        snippets: {
            type: Array,
            default: function() {
                return []
            }
        },
        lang: {
            type: String,
            default: 'text/html'
        },
        errors: {
            type: Array,
            default: function() {
                return []
            }
        },
        btnLabel: {
            type: String,
            default: 'Open editor'
        },
        withButton: {
            type: Boolean,
            default: true
        },
    },
    data : function() {
        return {
            loadEditor: false,
            editor: {
                show: false,
            },
            snippetSelected: ''
        }
    },
    computed: {
        content: {
            get() {
                return this.value;
            },

            set(val) {
                this.$emit('input', val)
            }
        },

        editorOptions() {
            return {
                tabSize: 4,
                line: true,
                autoRefresh: true,
                lineNumbers: true,
                foldGutter: true,
                firstLineNumber: 1,
                styleSelectedText: true,
                mode: "text/html",
                matchBrackets: true,
                showCursorWhenSelecting: true,
                theme: this.platformTheme()
            }
        }
    },
    methods: {
        controlActionsEvent(e, data) {
            this.$emit("controlAction", e, data);
        },

        onChange(code) {
            this.$emit("onInput", code);
        },

        showHint(cm) {
            cm.showHint({
                completeSingle: false,
                alignWithWord: true,
                hint: vueCodemirror.CodeMirror.hint.protokol
            });
        },
        
        platformTheme() {
            if (this.$store) {
                return this.$store.getters.getCurrentTheme == 'light' ? 'default' : 'material-palenight'
            }

            return 'material-palenight'
        }
    }
}
</script>